// extracted by mini-css-extract-plugin
export default {"zoom-modal":"ZoomModal_zoom-modal__bN4Aw"};